<app-sleep-upload-form
  *ngIf="shouldShow('SLEEP')"
  [formConfig]="formConfig!"
  [showPostMeasurementFields]="showPostMeasurementFields"
  [showPreMeasurementFields]="showPreMeasurementFields"
></app-sleep-upload-form>

<app-holter-ecg-upload-form
  *ngIf="shouldShow('HOLTER_ECG')"
  [formConfig]="formConfig!"
  [showPostMeasurementFields]="showPostMeasurementFields"
  [showPreMeasurementFields]="showPreMeasurementFields"
  [ecgTechnicianAnalysisOnlyEnabled]="ecgTechnicianAnalysisOnlyEnabled"
  [isHome]="isHome"
></app-holter-ecg-upload-form>

<app-ecg-atrial-fibrillation-upload-form
  *ngIf="shouldShow('ECG_ATRIAL_FIBRILLATION')"
  [formConfig]="formConfig!"
  [showPostMeasurementFields]="showPostMeasurementFields"
  [showPreMeasurementFields]="showPreMeasurementFields"
  [isHome]="isHome"
  [ecgTechnicianAnalysisOnlyEnabled]="ecgTechnicianAnalysisOnlyEnabled"
></app-ecg-atrial-fibrillation-upload-form>

<app-symptom-holter-upload-form
  *ngIf="shouldShow('SYMPTOM_HOLTER')"
  [formConfig]="formConfig!"
  [showPostMeasurementFields]="showPostMeasurementFields"
  [showPreMeasurementFields]="showPreMeasurementFields"
  [isHome]="isHome"
  [ecgTechnicianAnalysisOnlyEnabled]="ecgTechnicianAnalysisOnlyEnabled"
></app-symptom-holter-upload-form>

<app-blood-pressure-upload-form
  *ngIf="shouldShow('BLOOD_PRESSURE')"
  [formConfig]="formConfig!"
  [showPostMeasurementFields]="showPostMeasurementFields"
  [showPreMeasurementFields]="showPreMeasurementFields"
  [isHome]="isHome"
></app-blood-pressure-upload-form>
